import React from 'react';

export const listaPacientes = () => {
	return [
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '0',
			fecha: '22/09/2021',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '1',
			fecha: '23/09/2021',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '3',
			idPresupuesto: '2',
			fecha: '22/10/2021',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '3',
			fecha: '22/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '4',
			fecha: '23/04/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '2',
			idPresupuesto: '5',
			fecha: '24/04/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '3',
			idPresupuesto: '6',
			fecha: '25/05/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '2',
			idPresupuesto: '7',
			fecha: '26/05/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '2',
			idPresupuesto: '8',
			fecha: '30/05/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '9',
			fecha: '03/06/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '10',
			fecha: '04/06/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '11',
			fecha: '05/06/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '12',
			fecha: '03/07/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '3',
			idPresupuesto: '13',
			fecha: '03/08/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '14',
			fecha: '04/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '15',
			fecha: '21/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '3',
			idPresupuesto: '16',
			fecha: '22/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '3',
			idPresupuesto: '17',
			fecha: '23/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '18',
			fecha: '24/09/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '2',
			idPresupuesto: '19',
			fecha: '04/09/2021',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '1',
			idPresupuesto: '20',
			fecha: '05/03/2022',
		},
		{
			imagenPaciente:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Firisvision.com%2Fwp-content%2Fuploads%2F2019%2F01%2Fno-profile-1-1200x1200.png&f=1&nofb=1&ipt=eea6ea5b6cac717073b2c12bda3cde02a3f5e14e985ad9e1802bcda87096ca23&ipo=images',
			nombrePaciente: 'Paciente de prueba',
			descripcion: 'Descripcion de la informacion del cliente',
			precio: '10.95',
			cuidado: 'Cuidado personal',
			horasDias: '2',
			diasSemana: '4',
			estado: '0',
			idPresupuesto: '21',
			fecha: '21/01/2022',
		},
	];
};
